import { padLeftZero } from './padLeftZero';

// 单位时间ms
export function getTimer(value) {
    const d = parseInt(value / 3600 / 24);
    const h = parseInt((value / 3600) % 24);
    const m = parseInt((value / 60) % 60);
    const s = parseInt(value % 60);
    return { d, h, m, s };
}
export function getClockTimer(value) {
    const hour = parseInt(value / 3600);
    const minutes = parseInt((value / 60) % 60);
    const seconds = parseInt(value % 60);
    if (hour > 0) {
        const h = hour + '';
        const m = minutes + '';
        return h + '小时' + padLeftZero(m) + '分';
    } else {
        const m = minutes + '';
        const s = seconds + '';
        return m + '分' + padLeftZero(s) + '秒';
    }
}
